import React from "react";
import data from "./data.json";
import { useRef } from "react";
import { useDraggable } from "react-use-draggable-scroll";
import { InfiniteSlider } from "@/components/motion-primitives/infinite-slider";
import { ProgressiveBlur } from "@/components/motion-primitives/progressive-blur";

export default function SideProjects() {
  const ref = useRef(null);
  const { events } = useDraggable(ref);

  return (
    <div
      className="relative w-full h-[50vh] -translate-y-4"
      {...events}
      ref={ref}
    >
      <InfiniteSlider gap={12} speedOnHover={1} reverse>
        {data.saasProject.map((projectExp) => {
          const isClickable = projectExp.link !== "#";

          const content = (
            <img
              src={projectExp.src}
              alt={projectExp.projectname}
              className="w-auto min-h-[40vh] max-h-[40vh] h-[40vh] rounded-4xl"
            />
          );

          return (
            <div
              key={projectExp.id}
              className="dark:grayscale hover:dark:grayscale-0 hover:saturate-200 hover:scale-[1.02] transition-all duration-300 ease-in-out flex flex-col items-start gap-4"
            >
              {isClickable ? (
                <a
                  href={projectExp.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="relative pt-2 p-2 rounded-xl flex-shirk-0 w-auto justify-center overflow-y-hidden"
                >
                  {content}
                </a>
              ) : (
                <div className="relative pt-2 p-2 rounded-xl flex-shirk-0 w-auto justify-center overflow-y-hidden">
                  {content}
                </div>
              )}

              <p className="-mt-4 text-xs opacity-100 font-light pl-2">
                {projectExp.projectname}
              </p>
            </div>
          );
        })}
      </InfiniteSlider>

      <ProgressiveBlur
        className="pointer-events-none absolute top-0 left-0 h-full w-[80px]"
        direction="left"
        blurIntensity={1}
      />

      <ProgressiveBlur
        className="pointer-events-none absolute top-0 right-0 h-full w-[80px]"
        direction="right"
        blurIntensity={1}
      />
    </div>
  );
}